import { CouponScopeEnum, CouponValueTypeEnum } from './enum';

export const CouponValueTypeLabels = {
  [CouponValueTypeEnum.PERCENT]: 'Percentual (%)',
  [CouponValueTypeEnum.FIXED]: 'Valor fixo (R$)',
};

export const CouponScopeLabels = {
  [CouponScopeEnum.ALL]: 'Planos e Produtos',
  [CouponScopeEnum.PLAN]: 'Plano',
  [CouponScopeEnum.ADDON_TOTAL]: 'Total em produtos',
  [CouponScopeEnum.ADDON_ITEM]: 'A cada produto',
};
